import React from 'react'

export default function ViewAll({ children, top }) {
  return (
    <p
      className="headline2"
      style={{
        color: 'var(--primaryShades20)',
        cursor: 'pointer',
        marginTop: top,
      }}
    >
      {children}
    </p>
  )
}
